import { useCallback, useSyncExternalStore } from 'react';
import { REDUCED_MOTION_QUERY } from './motion';

export const PHONE_QUERY = '(max-width: 639px)';

export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const list = window.matchMedia(query);
      list.addEventListener('change', onChange);
      return () => list.removeEventListener('change', onChange);
    },
    [query],
  );
  return useSyncExternalStore(subscribe, () => window.matchMedia(query).matches);
}

export const useIsPhone = (): boolean => useMediaQuery(PHONE_QUERY);

export const useReducedMotion = (): boolean => useMediaQuery(REDUCED_MOTION_QUERY);

export type Variant = 'desktop' | 'phone';
export const useVariant = (): Variant => (useIsPhone() ? 'phone' : 'desktop');
